/**
 * Product brand assets — the single source of truth for the BuzzBit X logo.
 *
 * Merchant/workspace logos (Brand DNA, white-label, email {{logo_url}}) are
 * a different concern and must never read from here.
 *
 * To change the product logo: replace `client/public/logo.png` (full lockup:
 * wordmark + bee + growth mark + tagline). Static HTML (index.html, legal
 * pages, the service worker) and server emails read the same public path.
 * To change the square mark: edit `client/public/favicon.svg`, then run
 * `node scripts/generate-brand-icons.mjs` to refresh PNG/PWA/iOS icons.
 */
export const BRAND_NAME = 'BuzzBit X';

/** Public URL of the full lockup (wordmark + mark + tagline). */
export const BRAND_LOGO_SRC = '/logo.png';

/** Square mark used as the document / PWA / push icon. */
export const BRAND_FAVICON_SRC = '/favicon.svg';
export const BRAND_FAVICON_PNG_SRC = '/favicon.png';
export const BRAND_APPLE_TOUCH_ICON_SRC = '/apple-touch-icon.png';
